
export enum AppDatatableProcessingStatus {
    SUCCESS = "success",
    FAILURE = "failure"
}



// WEBPACK FOOTER //
// ./src/app/shared/datatable/enums/processing-status.enum.ts